import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLegalFirms, createLegalFirm, fetchLegalFirm, modifyLegalFirm, deleteLegalFirmApi, changeStatus } from '../../api/legalFirmApi';

export const getLegalFirms = createAsyncThunk('legalFirm/getLegalFirms', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchLegalFirms(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addLegalFirm = createAsyncThunk('legalFirm/addLegalFirm', async (payload, { rejectWithValue }) => {
  try {
    const response = await createLegalFirm(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getLegalFirmDetails = createAsyncThunk('legalFirm/getLegalFirmDetails', async (legalFirmId, { rejectWithValue }) => {
  try {
    const response = await fetchLegalFirm(legalFirmId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateLegalFirm = createAsyncThunk('legalFirm/updateLegalFirm', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyLegalFirm(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteLegalFirm = createAsyncThunk('legalFirm/deleteLegalFirm', async (legalFirmId, { rejectWithValue }) => {
  try {
    const response = await deleteLegalFirmApi(legalFirmId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('legalFirm/changeDefaultStatus', async (legalFirmId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(legalFirmId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const legalFirmSlice = createSlice({
  name: 'legalFirm',
  initialState: {
    legalFirms: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLegalFirms.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getLegalFirms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.legalFirms = action.payload;
      })
      .addCase(getLegalFirms.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default legalFirmSlice.reducer;
